import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { get } from 'scriptjs';

import { environment } from '../../../environments/environment';

import { IsApplicationService } from './is-application.service';
import { SSOAuthResult, SSOLoginType } from '../../shared/models/interfaces/sso.interface';
import { GoogleLoginResponseOnline, SocialLogin } from '@capgo/capacitor-social-login';

@Injectable({
  providedIn: 'root',
})
export class SSOGoogleService {
  constructor(private isApplicationService: IsApplicationService) {}

  login(): Observable<{
    ssoAuthResult: SSOAuthResult;
    loginType: SSOLoginType;
  }> {
    if (this.isApplicationService.isApplication()) {
      return this.loginFromApplication();
    } else {
      return this.loginFromDesktop();
    }
  }

  loginFromApplication(): Observable<{
    ssoAuthResult: SSOAuthResult;
    loginType: SSOLoginType;
  }> {
    return new Observable((observer) => {
      SocialLogin.initialize({
        google: {
          webClientId: environment.google_web_id,
          iOSClientId: environment.google_ios_id,
        },
      }).then(
        () => {
          SocialLogin.login({
            provider: 'google',
            options: {
              scopes: ['email', 'profile'],
            },
          }).then(
            (res) => {
              if (res) {
                const googleUser = res.result as GoogleLoginResponseOnline;

                if (googleUser?.accessToken?.token) {
                  observer.next({
                    ssoAuthResult: {
                      authResponse: {
                        accessToken: googleUser.accessToken.token,
                      },
                    },
                    loginType: SSOLoginType.DEFAULT,
                  });
                } else {
                  observer.error($localize`errGGLCO3-Erreur lors de la connexion`);
                }
              } else {
                observer.error($localize`errGGLCO4-Erreur lors de la connexion`);
              }
            },
            (err) => {
              if (!(err.errorMessage as string)?.includes('The user canceled the sign-in flow')) {
                observer.error($localize`errGGLCO1-Erreur lors de la connexion`);
              }
            }
          );
        },
        (err) => {
          observer.error($localize`errGGLCO2-Erreur lors de la connexion`);
        }
      );
    });
  }

  loginFromDesktop(): Observable<{
    ssoAuthResult: SSOAuthResult;
    loginType: SSOLoginType;
  }> {
    return new Observable((observer) => {
      get('https://accounts.google.com/gsi/client', () => {
        const client = google.accounts.oauth2.initTokenClient({
          client_id: environment.google_web_id,
          scope: 'email profile',
          callback: (tokenResponse) => {
            observer.next({
              ssoAuthResult: {
                authResponse: {
                  accessToken: tokenResponse.access_token,
                },
              },
              loginType: SSOLoginType.DEFAULT,
            });
          },
          error_callback: (err) => {
            console.error(err);
            observer.error(err.message);
          },
        });

        client.requestAccessToken();
      });
    });
  }

  logoutFromApplication() {
    SocialLogin.initialize({
      google: {
        webClientId: environment.google_web_id,
        iOSClientId: environment.google_ios_id,
      },
    }).then(() => {
      SocialLogin.logout({ provider: 'google' });
    });
  }
}
